import { Pipe, PipeTransform } from '@angular/core';

import { DateHelper } from '@helpers/date.helper';

@Pipe({
  name: 'contractReminderLate',
  standalone: true
})
export class ContractReminderLatePipe implements PipeTransform {
  transform(nextReminderDate: string): boolean {
    if (!nextReminderDate || DateHelper.isSameOrAfter(nextReminderDate, DateHelper.format(DateHelper.currentDate()))) {
      return false;
    }

    return true;
  }
}
